import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getDealerState } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/DealerDetails/Handlers/DisplayDealer";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
replaceInChain(chain, PopulateApiParameter, props => {
    const state = props.getState();
    const dealerState = getDealerState(state, props.parameter.dealerId.toLowerCase());
    if (!dealerState.value && !dealerState.isLoading) {
        props.apiParameter = { id: props.parameter.dealerId };
    }
});
